/* eslint-disable no-undef */
/* eslint-disable no-useless-escape */
'use strict';

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
	$.spinner().stop();

	var status;
	if (data.success) {
		status = 'alert-success';
		if($('input[name=jacSubscribeNewArrivalEmail]').length > 0 && $(button).hasClass('subscribe-new-arrival-email')) {
			$('input[name=jacSubscribeNewArrivalEmail]').addClass('success');
			$('input[name=jacSubscribeNewArrivalEmail]').parent().parent().append(
				'<span class="email-tick">&#10003</span>');
		}
	} else {
		status = 'alert-danger';
		if($('input[name=jacSubscribeNewArrivalEmail]').length > 0 && $(button).hasClass('subscribe-new-arrival-email')) {
			$('input[name=jacSubscribeNewArrivalEmail]').addClass('error');
			$(document).trigger('emailSubscribe:errorAnalytics');
		}		
	}

	if ($('.email-signup-message').length === 0) {
		$('.alert-message-block').append('<div class="email-signup-message"></div>');
	}
	$('.email-signup-message').append(
		'<div class="email-signup-alert ' +
		status +
		'">' +
		data.msg +
		'</div>'
	);

	setTimeout(function () {
		if (data.success) {
			$('input[name=jacSubscribeNewArrivalEmail]').val('');	
		}
		$('.email-signup-message').remove();
		$('.email-tick').remove();
		$('input[name=jacSubscribeNewArrivalEmail]').removeClass('error');
		$('input[name=jacSubscribeNewArrivalEmail]').removeClass('success');
		button.removeAttr('disabled');
	}, 3000);
}

module.exports = function () {

	$('#footercontent .chat').css({ 'bottom': $('.footer-bottom').height() });
	var backToTop = $('.back-to-top');
	$(window).scroll(function () {

		var trackLength;
		var winheight = $(window).height();
		var docheight = $(document).height();

		//measurement
		winheight = window.innerHeight || (document.documentElement || document.body).clientHeight;
		trackLength = docheight - winheight;

		//scrolled
		var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;
		var pctScrolled = Math.floor(scrollTop / trackLength * 100); // gets percentage scrolled (ie: 70 or NaN if tracklength == 0)

		if (pctScrolled > 69) {
			if ($(window).scrollTop() > 1) {
				backToTop.addClass('show');
			} else {
				backToTop.removeClass('show');
			}
		}
		else {
			backToTop.removeClass('show');
		}
	});

	$(window).resize(function () {

		$('#footercontent .chat').css({ 'bottom': $('.footer-bottom').height() });
	});

	backToTop.click(function (element) {
		var position = element && element.length ? element.offset().top : 0;
		$('html, body').animate({
			scrollTop: position
		}, 500);
	});

	$('.subscribe-email').on('click', function (e) {
		e.preventDefault();
		var url = $(this).data('href');
		var button = $(this);
		var emailId = $('input[name=hpEmailSignUp]').val();
		$.spinner().start();
		$(this).attr('disabled', true);
		$.ajax({
			url: url,
			type: 'post',
			dataType: 'json',
			data: {
				emailId: emailId
			},
			success: function (data) {
				displayMessage(data, button);
			},
			error: function (err) {
				displayMessage(err, button);
			}
		});
	});
	$('.subscribe-new-arrival-email').on('click', function (e) {
		e.preventDefault();
		var url = $(this).data('href');
		var button = $(this);
		var inputField = $('input[name=jacSubscribeNewArrivalEmail]');
		var emailVal = inputField.val();

		$.spinner().start();
		$(this).attr('disabled', true);
		$.ajax({
			url: url,
			type: 'post',
			dataType: 'json',
			data: {
				emailId: emailVal,
			},
			success: function (data) {
				if(data.success == true){
					$(document).trigger('emailSubscribe:success');
				}		
				displayMessage(data, button);		
			},
			error: function (err) {
				displayMessage(err, button);
			},
		});
	});

	$('.dropdown-toggle').on('click', function (e) {
		if ($(window).width() <= 768) {
			if ($(e.currentTarget).hasClass('show')) {
				$('.footer-middle-nav > li').addClass('d-none');
				$(e.currentTarget).parent().parent().removeClass('d-none');
			} else {
				$('.footer-middle-nav > li').removeClass('d-none');
			}
		}
	});
};
